var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgStars = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 1024 1536",
  preserveAspectRatio: "xMidYMax slice",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#FFF",
  fillOpacity: 0.3,
  transform: "translate(55 42)"
}, /*#__PURE__*/React.createElement("g", {
  id: "stars-first-layer"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 6,
  cy: 1009.5,
  rx: 2.5,
  ry: 2
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 138,
  cy: 1110.5,
  rx: 2.5,
  ry: 2
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 398,
  cy: 1055.5,
  rx: 2.5,
  ry: 2
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 719,
  cy: 1284.5,
  rx: 2.5,
  ry: 2
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 760,
  cy: 1155.5,
  rx: 2.5,
  ry: 2
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 635,
  cy: 1459.5,
  rx: 2.5,
  ry: 2
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 478,
  cy: 1335.5,
  rx: 2.5,
  ry: 2
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 322,
  cy: 1414.5,
  rx: 2.5,
  ry: 2
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 247,
  cy: 1234.5,
  rx: 2.5,
  ry: 2
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 154,
  cy: 1425.5,
  rx: 2.5,
  ry: 2
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 731,
  cy: 773.5,
  rx: 2.5,
  ry: 2
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 599,
  cy: 874.5,
  rx: 2.5,
  ry: 2
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 339,
  cy: 819.5,
  rx: 2.5,
  ry: 2
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 239,
  cy: 1004.5,
  rx: 2.5,
  ry: 2
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 113,
  cy: 863.5,
  rx: 2.5,
  ry: 2
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 102,
  cy: 1223.5,
  rx: 2.5,
  ry: 2
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 395,
  cy: 1155.5,
  rx: 2.5,
  ry: 2
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 826,
  cy: 943.5,
  rx: 2.5,
  ry: 2
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 626,
  cy: 1054.5,
  rx: 2.5,
  ry: 2
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 887,
  cy: 1366.5,
  rx: 2.5,
  ry: 2
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 6,
  cy: 241.5,
  rx: 2.5,
  ry: 2
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 138,
  cy: 342.5,
  rx: 2.5,
  ry: 2
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 398,
  cy: 287.5,
  rx: 2.5,
  ry: 2
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 719,
  cy: 516.5,
  rx: 2.5,
  ry: 2
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 760,
  cy: 387.5,
  rx: 2.5,
  ry: 2
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 635,
  cy: 691.5,
  rx: 2.5,
  ry: 2
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 478,
  cy: 567.5,
  rx: 2.5,
  ry: 2
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 322,
  cy: 646.5,
  rx: 2.5,
  ry: 2
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 247,
  cy: 466.5,
  rx: 2.5,
  ry: 2
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 154,
  cy: 657.5,
  rx: 2.5,
  ry: 2
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 731,
  cy: 5.5,
  rx: 2.5,
  ry: 2
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 599,
  cy: 106.5,
  rx: 2.5,
  ry: 2
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 339,
  cy: 51.5,
  rx: 2.5,
  ry: 2
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 239,
  cy: 236.5,
  rx: 2.5,
  ry: 2
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 113,
  cy: 95.5,
  rx: 2.5,
  ry: 2
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 102,
  cy: 455.5,
  rx: 2.5,
  ry: 2
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 395,
  cy: 387.5,
  rx: 2.5,
  ry: 2
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 826,
  cy: 175.5,
  rx: 2.5,
  ry: 2
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 626,
  cy: 286.5,
  rx: 2.5,
  ry: 2
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 887,
  cy: 598.5,
  rx: 2.5,
  ry: 2
})))));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgStars, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Stars.d63086ef.svg";
export { ForwardRef as ReactComponent };